import {html} from 'lit-html';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {optionClassMap} from '../template/template-util.js';
import Upload from '../upload/upload';

TemplateRegistry.templates['upload-lift'] = (option, config, onChange, onErrorClear, getOption) => {

    // only if uuid is of the upload field is provided
    if(option.params.uuid){
        // PREVIEW: selected field changed > destroy field & controller
        if(option._controller){
            // field different
            if(option._controller.field && (option._controller.field.config.uuid !== option.params.uuid)){
                option._controller.field.destroy();
                delete option._controller;
            }
            // editor mode field not initialized (required when field is missing at the beginning)  INFO: BROKE when options.render() is called twice on init
            else if(config.editorMode && option._controller.notfound){
                delete option._controller;
            }
        }

        let init = option._controller === undefined;

        // get or create upload controller
        option._controller = option._controller || Upload.getInstance().controllerLift(option, config.product, config.productForm, onChange, getOption);

        if(!init){
            option._controller.update(option, config.productForm);
        }

        // hacky fix for editorMode when the options are updated the controllerLift(<option>) reference changes
        option._controller.option = option;

        // NEW: support cropLabel setting on option (upload-lift only) (required when not using any live preview)
        let cropLabel = option._layer && option._layer.params.cropLabel ? option._layer.params.cropLabel : option.params.cropLabel;

        // NEW: live crop button below UploadLift component    || NEW: upload-lift _cropConfig update with dimension option (works without live preview) || NEW: upload-lift editor edit crop
        return html`
            <div class="cl-po--upload-lift ${classMap(optionClassMap(option))}">
                <div class="cl-po--upload-lift-${option.id}"></div>
                ${ (option.value && ( (option._layer && option._layer.params.crop) || option._controller._cropConfig || option.params.cropEdit) ) ? html`
                    <label class="cl-po--input cl-po--upload-lift-crop ${classMap({'has-label': cropLabel})}" @click=${e => option._controller.crop(option,config.productForm)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" ><path fill="currentColor" d="M15 17v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v15h8zm2 5V7H9V5h9a1 1 0 0 1 1 1v11h3v2h-3v3h-2z" /></svg>
                        ${cropLabel ?  html`<span class="cl-po--crop-label">${cropLabel}</span>` : null}
                    </label>
                `: null}

                ${option.value && option._layer && option._layer.params.layerEditor ?  html`${TemplateRegistry.templates['layer_editor'](option, config, onChange)}`: null}
            </div>`;
    }

    return null;
}